// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { RenderSelection } from '@/vue3/api/models';

export const useRenderSelectionService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive
    const renderSelections = ref<RenderSelection[]>([]);

    // methods
    const getRenderSelection = async (
        courseSchemaId,
    ): Promise<RenderSelection> => {
        const res = await axios.get(
            `${apiUrl}/render-selections/${courseSchemaId}`,
        );
        renderSelections.value = res.data;
        return res.data;
    };

    const createRenderSelection = async (
        RenderSelection: RenderSelection,
    ): Promise<RenderSelection> => {
        const res = await axios.post(
            `${apiUrl}/render-selections`,
            RenderSelection,
        );
        return res.data;
    };

    const updateRenderSelection = async (
        RenderSelection: RenderSelection,
    ): Promise<RenderSelection> => {
        const res = await axios.put(
            `${apiUrl}/render-selections`,
            RenderSelection,
        );
        return res.data;
    };

    const deleteRenderSelecton = async (): Promise<RenderSelection> => {
        const res = await axios.deleteId(`${apiUrl}/render-selections`);
        return res.data;
    };

    return {
        getRenderSelection,
        createRenderSelection,
        updateRenderSelection,
        renderSelections,
        deleteRenderSelecton,
    };
};
